import './style.scss';
import { UserPostComment } from '../../types/posts';
import { PAGE_URLS } from '../../constants/hrefLinks';

interface AppUserCommentProps {
	data: UserPostComment
}

function AppUserComment({data}: AppUserCommentProps) {
	const minsAgo: number = Math.floor((new Date().getTime() - Number(data.commentDate)) / 1000 / 60)
	const hoursAgo: number = Math.floor(minsAgo / 60)
	const daysAgo: number = Math.floor(hoursAgo / 24)
	
	return (
		<div className='app-user-comment-wrap'>
			<div className='app-user-comment-details-wrap'>
				<img 
					className='app-user-comment-profile-img'
					src={data.sourceImgSrc}
					alt='Posters Profile'
					onClick={() => {
						window.location.replace(`${PAGE_URLS.APP_PROFILE_USER}?id=${data.sourceUserId}`)
					}}
				/>
				<div className='app-user-comment-info'>
					<a 
						className='app-user-comment-name'
						href={`${PAGE_URLS.APP_PROFILE_USER}?id=${data.sourceUserId}`}
						aria-label={`Visit the profile page for User ${data.sourceUserId}`}
					>
						{data.sourceName.replace(' ', '.').toLowerCase()}
					</a>
					<div className='app-user-comment-time'>
						{daysAgo > 0 ? `${daysAgo} days ` : hoursAgo > 0 ? `${hoursAgo} hours ` : `${minsAgo} mins `} 
						ago
					</div>
				</div>
			</div>
			<div className='app-user-comment-content-wrap'>
				{data.commentMsg}
			</div>
		</div>
	)
}

export default AppUserComment
